import { Component, Input, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CaFormFieldComponent, CaLabel } from '@global-front-components/ui/form-field';
import { CaInputDirective } from '@global-front-components/ui/input';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { CaModalOverlayRef } from '@global-front-components/ui/modal-overlay';
import { AuthService } from '../../services/api/auth.service';
import { UsuarioPaeonia } from '../../model/menu.model';
import { SegurosApiService } from '../../services/api/seguros-api.service';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
	selector: 'app-modal-suplantacion',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule,
		CaFormFieldComponent,
		CaLabel,
		CaInputDirective,
		CaButtonComponent
	],
	templateUrl: './modal-suplantacion.component.html',
	styleUrls: ['./modal-suplantacion.component.scss']
})
export class ModalSuplantacionComponent implements OnDestroy {
	constructor(
		private authService: AuthService,
		private segurosService: SegurosApiService,
		private _modalRef: CaModalOverlayRef<ModalSuplantacionComponent>,
		private router: Router
	) { }
	usuarioBuscar = '';
	usuarioSuplantar$ = new BehaviorSubject<UsuarioPaeonia | null>(null);

	@Input() data: any;

	getUsuarioBuscar(usuarioBuscar: string): void {
		this.usuarioBuscar = usuarioBuscar;
	}

	closeDialog(text?: string): void {
		if (text) {
			this._modalRef.close(text);
		} else {
			this._modalRef.close();
		}
	}

	buscarUsuario(usuarioBuscar: string) {
		if (usuarioBuscar === '') return;
		this.segurosService.buscarUsuario(usuarioBuscar).subscribe({
			next: (usuario) => {
				this.usuarioSuplantar$.next(usuario);
			},
			error: (err) => console.error('Error buscando usuario:', err),
		});
	}

	suplantar() {
		const usuario = this.usuarioSuplantar$.getValue();
		if (!usuario) return;

		this.authService.suplantar(usuario.uid).subscribe({
			next: () => {
				this.closeDialog();
				this.router.navigate(['/']);
			},
			error: (err) => console.error('Error suplantando usuario:', err),
		});
	}

	ngOnDestroy(): void {
		this.usuarioSuplantar$.next(null);
		this.usuarioSuplantar$.complete();
		this.usuarioBuscar = '';
		this.closeDialog();
	}
}
